import { render, staticRenderFns } from "./CatEditor.vue?vue&type=template&id=4fae0ec0&scoped=true&"
import script from "./CatEditor.vue?vue&type=script&lang=js&"
export * from "./CatEditor.vue?vue&type=script&lang=js&"
import style0 from "./CatEditor.vue?vue&type=style&index=0&id=4fae0ec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae0ec0",
  null
  
)

export default component.exports